import Button from "./UI/Button";

export default Button;